let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i57oW")).then(() => parcelRequire('8aLn9'));